
//export const API_BASE = 'http://localhost:5000';


export const API_BASE = process.env.REACT_APP_API_URL || 'https://api.liber.am';
